export default __webpack_public_path__ + "static/media/Terminal 2 - Layout Segregação de Cargas Rev 27.b13171e5.pdf";